<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Proyecto {{ form.nombre }}</h3>
        <label>
          <div v-show="form.estado == 'N'" class="noti-secondary">Estado: <strong>NUEVO</strong></div>
          <div v-show="form.estado == 'A'" class="noti-success">Estado: <strong>PENDIENTE</strong></div>
          <div v-show="form.estado == 'I'" class="noti-danger">Estado: <strong>ANULADO</strong></div>
          <div v-show="form.estado == 'FF'" class="noti-primary">Estado: <strong>FINALIZADO</strong></div>
        </label>
      </div>
      <div class="layout__controls">
        <button v-if="consultar" @click="botonBuscar()" class="btn-info btn--bigger">
          <i class="fa fa-search"></i>
          <span>Buscar</span>
        </button>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field :disabled="disabledInput" v-model="form.codigo" id="codigo" placeholder="Escriba un código...">
                    <span>Código*</span>
                    <span v-if="errores.codigo" class="helper-text text-danger" slot="helper">
                      {{ errores.codigo[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field select2">
                  <div class="form-group">
                    <div class="select2-field">
                      <v-select
                        :disabled="disabledInput"
                        @input="inputPersona"
                        @search="onSearchPersona"
                        :tooltip="selectedPersona?selectedPersona.nombre:null"
                        placeholder="Busque y seleccione..."
                        id="persona"
                        v-model="selectedPersona"
                        :options="optionPersonas"
                        label="nombre"
                      ></v-select>
                      <label for="persona">Cliente*</label>
                      <span v-if="errores.persona_id" class="helper-text text-danger" slot="helper">
                        {{ errores.persona_id[0] }}
                      </span>
                    </div>
                    <button :disabled="disabledInput" @click="buscarPersona()" class="btn-info" type="button">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <input-field :disabled="disabledInput" v-model="form.nombre" id="nombre" placeholder="Escriba un nombre...">
                  <span>Nombre*</span>
                  <span v-if="errores.nombre" class="helper-text text-danger" slot="helper">
                    {{ errores.nombre[0] }}
                  </span>
                </input-field>
              </div>
              <div class="col-xs-12 col-md-6">
                <input-field :disabled="disabledInput" v-model="form.descripcion" id="descripcion" placeholder="Escriba una descripción...">
                  <span>Descripción*</span>
                  <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                    {{ errores.descripcion[0] }}
                  </span>
                </input-field>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker
                      :disabled="disabledInput"
                      id="fecha_inicio"
                      v-model="form.fecha_inicio"
                      locale="es"
                      only-datetime
                      no-label
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm"
                      label="Seleccione fecha..."
                    />
                    <label>Fecha inicio*</label>
                    <span v-if="errores.fecha_inicio" class="helper-text text-danger" slot="helper">
                      {{ errores.fecha_inicio[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button v-if="crear && editar" :disabled="disabledInput" @click="botonGuardar()" class="btn-success" type="button"><i class="fa fa-save"></i><span>Guardar</span></button>
            <button @click="botonLimpiar()" class="btn-light btn--text" type="button"><i class="fa fa-plus"></i><span>Nueva</span></button>
            <button v-if="eliminar" @click="botonAnular()" v-show="tieneId && (form.estado != 'N' && form.estado != 'I' && form.estado != 'FF')" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i><span>Eliminar</span></button>
            <button @click="botonReactivar()" v-show="tieneId && form.estado == 'I'" type="button" class="btn-success btn--text"><i class="fa fa-power-off"></i><span>Re-activar</span></button>
            <button @click="botonFinalizar()" v-show="tieneId && form.estado != 'FF'" type="button" class="btn-primary"><i class="fa fa-flag-checkered"></i><span>Finalizar</span></button>
          </div>
        </div>
      </div>
    </div>
    <modal width="55%" height="auto" name="listaPersonas" scrollable>
      <lista-personas tipoFiltro="C" :filterStatus="false" @selected="seleccionarPersona"/>
    </modal>
    <modal :width="'80%'" height="auto" :scrollable="true" name="modalListaProyectos">
      <listaProyectos enabledExcel @selected="seleccionarProyecto"/>
    </modal>
  </div>
</template>
<script>
export default {
  props: {
    consultar: {
			type: Boolean,
			required: false,
		},
		crear: {
			type: Boolean,
			required: false,
		},
		editar: {
			type: Boolean,
			required: false,
		},
		eliminar: {
			type: Boolean,
			required: false,
		},
  },
  data() {
    return {
      disableButton: false,
      optionPersonas: [],
      selectedPersona: null,
      form: {
        id: '',
        codigo: '',
        persona_id: '',
        nombre: '',
        descripcion: '',
        fecha_inicio: '',
        estado: 'N',
      },
      errores: {
        codigo: undefined,
        persona_id: undefined,
        nombre: undefined,
        descripcion: undefined,
        fecha_inicio: undefined,
      }
    }
  },
  computed: {
    tieneId: function(){
      return this.form.id != '' && this.form.id != null;
    },
    disabledInput: function(){
      return this.form.estado == 'I' || this.form.estado == 'FF';
    }
  },
  methods: {
    seleccionarPersona: function(persona){
      this.selectedPersona = persona;
      this.form.persona_id = persona.id;
      this.$modal.hide('listaPersonas');
    },
    buscarPersona: function(){
      this.$modal.show('listaPersonas');
    },
    inputPersona: function(){
      if(this.selectedPersona)
        this.form.persona_id = this.selectedPersona.id;
      else{
        this.form.persona_id = '';
        this.selectedPersona = null;
      }
    },
    onSearchPersona: function(search, loading) {
      if(search.length) {
        loading(true);
        this.searchingPersona(loading, search, this);
      }
    },
    searchingPersona: _.debounce((loading, search, vm) => {
      fetch(`${url}/consultar-personas/?search=${search}&es_cliente=S`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response => response.json()).then(data => {
        vm.optionPersonas = data;
        loading(false);
      });
    }, 350),
    seleccionarProyecto: function(row){
      this.form.id = row.id;
      this.form.codigo = row.codigo;
      this.form.persona_id = row.persona_id;
      this.selectedPersona = row.persona;
      this.form.nombre = row.nombre;
      this.form.descripcion = row.descripcion;
      this.form.fecha_inicio = row.fecha_inicio;
      this.form.estado = row.estado;
      this.$modal.hide('modalListaProyectos');
    },
    botonBuscar: function(){
      this.$modal.show('modalListaProyectos');
    },
    limpiarCampos: function(){
      this.selectedPersona = null;
      this.form.id = '';
      this.form.codigo = '';
      this.form.persona_id = '';
      this.form.nombre = '';
      this.form.descripcion = '';
      this.form.fecha_inicio = '';
      this.form.estado = 'N';
    },
    limpiarErrores: function(){
      this.errores.codigo = undefined;
      this.errores.persona_id = undefined;
      this.errores.nombre = undefined;
      this.errores.descripcion = undefined;
      this.errores.fecha_inicio = undefined;
    },
    botonLimpiar: function(){
			swal.fire({
				title: '¿Deseas limpiar los campos?',
				text: "Esta acción requiere de confirmación.",
				type: 'question',
				showCancelButton: true,
				confirmButtonText:'Aceptar'
				}).then((result) => {
					if (result.value) {
						this.limpiarCampos();
						this.limpiarErrores();
					}
      });
		},
    guardarDatos: function(btn_estado = null){
      let title = '¿Deseas guardar el proyecto?', mensaje_respuesta = 'El proyecto han sido almacenado.';
      if(this.tieneId && btn_estado != null){
        if(btn_estado == 'A'){
          title = '¿Deseas Anular el proyecto?';
          mensaje_respuesta = 'El proyecto han sido anulado.';
        }
        else if(btn_estado == 'R'){
          title = '¿Deseas Re-activar el proyecto?';
          mensaje_respuesta = 'El proyecto han sido re-activado.';
        }
        else if(btn_estado == 'F'){
          title = '¿Deseas Finalizar el proyecto?';
          mensaje_respuesta = 'El proyecto han sido finalizado.';
        }
      }
      swal.fire({
        title,
        text: "Esta acción requiere de confirmación.",
        type: 'question',
        showCancelButton: true,
        confirmButtonText:'Aceptar'
      }).then((result) => {
        if (result.value) {
          this.limpiarErrores();
          let urlApi = null, method = 'POST';
          if(this.tieneId){
            if(btn_estado == 'A' || btn_estado == 'R'){
              urlApi = url + '/proyectos/delete/' +this.form.id;
              method = 'DELETE';
            }
            else if(btn_estado == 'F'){
              urlApi = url + '/proyectos/finalizar/' +this.form.id;
              method = 'DELETE';
            }
            else{
              urlApi = url + '/proyectos/update/' +this.form.id;
              method = 'PUT';
            }
          }
          else
            urlApi = url + '/proyectos/store';
          axios({
            method,
            url: urlApi,
            data: this.form
          }).then(response => {
            this.form.id = response.data.id;
            this.form.estado = response.data.estado;
            swal.fire('Aviso', mensaje_respuesta, 'success');
          }).catch(error => {
            if(error !== undefined && error !== null){
              let response = error.response;
              if (response !== undefined && response !== null){
                let status = response.status;
                if(status === 422){
                  this.errores = response.data.errors;
                  swal.fire('Hubo un error en el formulario.', 'Aviso', 'warning');
                  return;
                }
                if(status === 512){
                  swal.fire('Error', response.data.message, 'error');
                  return;
                }
              }
            }
            swal.fire('Hubo un error, intente nuevamente.', 'Error', 'error');
          });
        }
      });
    },
    botonGuardar: function(){
      this.guardarDatos();
    },
    botonAnular: function(){
      this.guardarDatos('A');
    },
    botonReactivar: function(){
      this.guardarDatos('R');
    },
    botonFinalizar: function(){
      this.guardarDatos('F');
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/procesos/Proyectos.vue